function formatOrders(orders) {
    return orders.map(formatOrder);
}

function formatOrder(order) {
    const {
        processingId,
        cancellation = {},
    } = order;
    const grouping = order.tickets[0]; // current system has exactly 1 ticket
    const tripDetails = grouping.trips[0]; // current system has exactly 1 trip
    const { ticket } = grouping;

    return {
        processingId,
        cancellation: _formatCancellation(cancellation),
        ticket: _formatTicket(ticket, processingId),
        travelers: grouping.travelers,
        tripDetails: _formatTripDetails(tripDetails),
    };
}

function _formatCancellation(cancellation) {
    return {
        isCancelable: cancellation.status === 'REFUNDABLE' && !cancellation.requiresCancelCheck,
        isCanceled: cancellation.status === 'CANCELLED',
        cancelDateTimeUTC: cancellation.cancelDateTimeUTC,
        refund: _formatRefund(cancellation.refund),
        requiresCancelCheck: cancellation.requiresCancelCheck,
    };
}

function _formatRefund(refund) {
    if (!refund) {
        return;
    }

    const totalReductions = (refund.reductions || [])
        .reduce((total, reduction) => {
            return total + reduction.amount;
        }, 0);

    return {
        ...refund,
        hasCancellationFee: totalReductions > 0,
        totalReductions,
    };
}

function _formatTripDetails(tripDetails) {
    return {
        ...tripDetails,
        departStation: _formatStation(tripDetails.departStation),
        arriveStation: _formatStation(tripDetails.arriveStation),
    };
}

function _formatStation(station) {
    return {
        ...station,
        address: _formatAddress(station.address),
    };
}

function _formatAddress(address) {
    return {
        ...address,
        stateProvince: address.state,
    };
}

function _formatTicket(ticket, processingId) {
    const {
        url: urlForPollingTicket,
        ...cleanedTicket
    } = ticket;
    const {
        deliveryInstructions = {},
        status,
    } = cleanedTicket;
    const isWillCall = deliveryInstructions.type === 'WILL_CALL';
    const isAvailable = status === 'available';

    return {
        ...cleanedTicket,
        isAvailable,
        isWillCall,
        processingId,
        urlForPollingTicket,
    };
}

export {
    formatOrder,
    formatOrders,
};
export default {
    formatOrders,
    formatOrder,
};
